'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n.React');

var _DashedLabel = require('ui-addon-conversations/components/labels/DashedLabel');

var _DashedLabel2 = _interopRequireDefault(_DashedLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UrlMarker(_ref) {
  var url = _ref.url;

  return _react2.default.createElement(
    _DashedLabel2.default,
    null,
    _react2.default.createElement(_I18n.FormattedHTMLMessage, { message: 'chat.urlMarker', options: { url: url } })
  );
}

UrlMarker.propTypes = {
  url: _react.PropTypes.string.isRequired
};

exports.default = UrlMarker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/js/components/labels/UrlLabel.js
// module id = 408
// module chunks = 0 1